export const getHasUserInteracted = state => state.hasUserInteracted;
